import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Building2, Briefcase, Cpu, ArrowRight } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TYPES = [
  { key: "institutional", label: "Partenaires Institutionnels", icon: Building2, desc: "Institutions publiques qui soutiennent nos actions educatives." },
  { key: "corporate", label: "Entreprises Mecenes", icon: Briefcase, desc: "Entreprises engagees dans notre mission d'inclusion." },
  { key: "tech", label: "Partenaires Technologiques", icon: Cpu, desc: "Acteurs du numerique qui co-construisent nos programmes." },
];

export default function PartnersPage() {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    axios.get(`${API}/partners`).then((r) => setPartners(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="partners-page" className="pt-24">
      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="font-body text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-blue-400 mb-6">
            Nos Partenaires
          </p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-slate-50 mb-8 leading-[1.1]">
            Ensemble pour l'education inclusive
          </h1>
          <p className="font-body text-base md:text-lg font-light text-slate-300 max-w-3xl">
            Nos partenaires sont au coeur de notre mission. Institutions, entreprises et acteurs du numerique, ils contribuent a faire de l'education un levier d'egalite.
          </p>
        </div>
      </section>

      <div className="section-divider" />

      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-20">
          {TYPES.map((type) => {
            const filtered = partners.filter((p) => p.type === type.key);
            if (filtered.length === 0) return null;
            return (
              <div key={type.key} data-testid={`partners-${type.key}`}>
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-lg bg-blue-500/20 flex items-center justify-center">
                    <type.icon className="w-5 h-5 text-blue-400" />
                  </div>
                  <h2 className="font-heading text-2xl md:text-3xl font-light text-slate-50">{type.label}</h2>
                </div>
                <p className="font-body text-sm text-slate-400 mb-8">{type.desc}</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {filtered.map((p) => (
                    <a
                      key={p.id}
                      href={p.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`partner-${p.name.toLowerCase().replace(/\s+/g, '-')}`}
                      className="bg-slate-900/50 border border-white/10 rounded-2xl p-6 hover:border-blue-500/30 transition-all duration-300 group"
                    >
                      <h3 className="font-body text-base font-medium text-slate-50 mb-2 group-hover:text-blue-400 transition-colors">
                        {p.name}
                      </h3>
                      <p className="font-body text-sm text-slate-400">{p.description}</p>
                    </a>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <div className="section-divider" />

      {/* Become a Partner CTA */}
      <section className="py-24 md:py-32">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <h2 className="font-heading text-4xl md:text-5xl font-light text-slate-50 mb-6">
            Devenir partenaire
          </h2>
          <p className="font-body text-base md:text-lg text-slate-400 mb-10 max-w-2xl mx-auto">
            Vous souhaitez rejoindre notre ecosysteme de partenaires ? Contactez-nous pour explorer les modalites de collaboration.
          </p>
          <Link
            to="/contact"
            data-testid="become-partner-cta"
            className="inline-flex items-center gap-2 bg-blue-500 hover:bg-blue-400 text-white px-8 py-4 rounded-full font-body font-medium transition-all duration-300"
          >
            Nous contacter <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
